if (!customElements.get('zs-details-peek')) {
  customElements.define('zs-details-peek', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const full = this.querySelector('.zs-details-peek__full');
      const preview = this.querySelector('.zs-details-peek__preview');
      const toggle = this.querySelector('.zs-details-peek__toggle');
      const grid = full?.querySelector('.zk-details-grid');
      if (!full || !preview || !toggle) return;
      this.dataset.ready = 'true';
      const previewPage = document.createElement('div');
      previewPage.className = 'zk-details-page';
      if (grid) {
        const previewGrid = grid.cloneNode(false);
        Array.from(grid.children).forEach((item, index) => {
          const clone = item.cloneNode(true);
          if (index >= 4) clone.setAttribute('aria-hidden', 'true');
          previewGrid.append(clone);
        });
        previewPage.append(previewGrid);
      } else {
        previewPage.classList.add('rte');
        Array.from(full.childNodes).forEach(item => {
          if (item.nodeType !== Node.ELEMENT_NODE || !item.matches('style, script')) previewPage.append(item.cloneNode(true));
        });
      }
      previewPage.querySelectorAll('[id]').forEach(item => item.removeAttribute('id'));
      preview.append(previewPage);
      if (full.scrollHeight <= 124) return;
      preview.removeAttribute('aria-hidden');
      const setExpanded = expanded => {
        full.hidden = !expanded;
        preview.hidden = expanded;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.querySelector('span').textContent = expanded ? 'Vis mindre' : 'Vis mer';
      };
      setExpanded(false);
      toggle.hidden = false;
      toggle.addEventListener('click', () => setExpanded(toggle.getAttribute('aria-expanded') !== 'true'));
    }
  });
}
